import APIModel from "../APIModel";

export default class Services extends APIModel {
  private readonly resourceUrl: string;

  constructor() {
    super();
    this.resourceUrl = "service_types";
  }

  async getData(params: object): Promise<any> {
    return await this.http
      .ignoreGlobalPreloader()
      .get(`${this.resourceUrl}`, params);
  }

  async getForEdit(id: number): Promise<any> {
    return await this.http.get(`${this.resourceUrl}/${id}/edit`);
  }

  async getListWithFilters(params: any = {}): Promise<any> {
    return await this.http.get(`${this.resourceUrl}/list_with_filters`, params);
  }

  async show(params: any = {}): Promise<any> {
    return await this.http.get(`${this.resourceUrl}/show`, params);
  }

  async getList(): Promise<any> {
    return await this.http.get(`${this.resourceUrl}/list`, {});
  }

  async edit(id: number, payload: object): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .useFormData()
      .post(`${this.resourceUrl}/${id}?_method=PATCH`, payload);
  }

  async create(payload: any): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .useFormData()
      .post(`${this.resourceUrl}`, payload);
  }

  async delete(id: any): Promise<any> {
    return await this.http.delete(`${this.resourceUrl}`, { id });
  }
}
